// data/customers.js
export const customers = [
  {
    id: 1,
    name: "삼성전자",
    address: "서울특별시 서초구 서초대로74길 11",
    phone: "02-2255-0114"
  },
  {
    id: 2,
    name: "LG전자",
    address: "서울특별시 영등포구 여의대로 128",
    phone: "02-3777-1114"
  },
  {
    id: 3,
    name: "네이버",
    address: "경기도 성남시 분당구 불정로 6",
    phone: "1588-3820"
  },
  {
    id: 4,
    name: "카카오",
    address: "제주특별자치도 제주시 첨단로 242",
    phone: "1577-3754"
  },
  {
    id: 5,
    name: "현대자동차",
    address: "서울특별시 서초구 헌릉로 12",
    phone: "02-3464-1114"
  }
];

// 새 고객 추가 함수 (실제 프로젝트에서는 API 호출로 대체)
export const addCustomer = (customerData) => {
  const newId = Math.max(...customers.map(c => c.id)) + 1;
  const newCustomer = { id: newId, ...customerData };
  customers.push(newCustomer);
  return newCustomer;
};

// 고객 검색 함수
export const findCustomerByName = (name) => {
  return customers.find(customer => 
    customer.name.toLowerCase().includes(name.toLowerCase())
  );
};